module.exports = __webpack_public_path__ + "lk.svg?3ce70e5002961066169f54aff5492201";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/lk.svg
// module id = 1469
// module chunks = 0